module.exports = __webpack_public_path__ + "5d67aa995e6e50160ab7a5732eb2429f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/FixedDirectionalityON.mp4
// module id = 393
// module chunks = 0